import axios from "axios";
import config from "../../../../config";

/*
  * getHostDetails() shows and dynamically renders the assign host modal
 */
export const getHostDetails = (accessToken, hostIDType, setHostDetails, setIsLoading, setShowGenericError= ()=>{}) => {
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accessToken
    };

    let data = {
        "host_id_type": hostIDType,
        "req_source": "KSM_EXTERNAL"
    };

    setShowGenericError(false)
    setIsLoading(true);

    axios.post(
        config.request_license.HOST_TYPE_DETAILS,
        data,
        {headers: headers}
    )
        .then((response) => {
            if (response.status === 200) {
                let data = typeof response.data === 'undefined' ? [] : response.data;

                let isSerial = data.get_serial.toUpperCase() || "";
                let hostPatterns = data.host_id_info.patterns || [];
                let serialPatterns = data.serial_number_info.patterns || [];


                // cast pattern strings to regex
                // note: regex casting removes addtional \ character for all regex patterns
                // ex. ^\\w{1,20}$ becomes ^\w{1,20}$
                hostPatterns.length ? hostPatterns = hostPatterns.map(pattern => new RegExp(pattern))
                    : hostPatterns = [];
                serialPatterns.length ? serialPatterns = serialPatterns.map(pattern => new RegExp(pattern))
                    : serialPatterns = [];

                // if optional serial numbers append empty string pattern to valid serial number patterns
                if (isSerial === "O") {
                    let emptyPattern = new RegExp("^$");
                    serialPatterns.push(emptyPattern);
                }

                data.host_id_info.patterns = hostPatterns
                data.serial_number_info.patterns = serialPatterns


                // list host id suggestions as "host id, alias"
                // if alias is the same as host id, omit alias from suggestion
                if (data.user_profile_tagged_host_ids.length > 0) {
                    if (typeof data.user_profile_tagged_host_ids[0] !== 'string') {
                        data.user_profile_tagged_host_ids = data.user_profile_tagged_host_ids.map(profile => {
                            let suggestion = profile.node_id !== profile.alias ? profile.node_id + ', ' + profile.alias
                                : profile.node_id;

                            return {
                                ...profile,
                                suggestion: suggestion
                            }
                        });
                    }
                }
                setHostDetails(data)
            }
        })
        .catch((error) => {
            console.log("ERROR: Failed to POST Host Type Details", error);
            setShowGenericError(true)
        })
        .finally(() => {
            setIsLoading(false)
        });
}


export const saveHostToProfile = (accessToken, setIsLoading, showError, nextMethod, hostIDs, savedHostInfo, hostDetails, serialNumber = '', hostFile = '', source = 'KSM_EXTERNAL') => {
    let headers = {
        'Authorization': 'Bearer ' + accessToken
    };

    let host_val = [];
    hostIDs.forEach((host) => {
        host_val.push(host?.trim() || '');
    })


    let inputJSON = {
        "host_id_type": hostDetails.host_id_type || "",
        "host_val": host_val,
        "serial_number": serialNumber?.trim() || '',
        "alias": savedHostInfo['alias']?.trim() || '',
        "asset_info": savedHostInfo['asset_info']?.trim() || '',
        "city": savedHostInfo['city']?.trim() || '',
        "state": savedHostInfo['state']?.trim() || '',
        "country": savedHostInfo['country']?.trim() || '',
        "notes": savedHostInfo['notes']?.trim() || '',
        "source": source,
    }

    let data = {
        "module": "LICENSE",
        "sub_module": "HOST_ASSIGN",
        "action": "SAVE",
        "input_json": inputJSON
    }

    let formData = new FormData();
    formData.append('File', hostFile);
    formData.append('Data', JSON.stringify(data));

    setIsLoading(true);

    axios.post(
        config.ea_request_license.HOST,
        formData,
        {headers: headers}
    )
        .then((response) => {
            if (response.status === 200) {
                nextMethod()
            }
        })
        .catch((error) => {
            console.log("ERROR: Failed to POST Host Assignment Save Host ID", error);
            let errorCode = error.response?.data?.error_code ?? "";
            switch (errorCode) {
                case "MOD_EA_160":
                case 'MOD_HSMGMNT_1':
                    showError('alias');
                    break;
                default:
                    showError('generic');
                    break;
            }
            setIsLoading(false);
        });
}